import Vue from 'vue';

const hashidePermission = {
    install(Vue,options) {
        //自定义指令v-nothas：
        Vue.directive('hashide', {
            //inserted：被绑定元素插入父节点时调用
            inserted: function (el, binding) {
                if (Vue.prototype.$_hashide(binding.value)) {
                    
					if (el.parentNode) {
                        el.parentNode.removeChild(el);
                    } else {
                        el.style.display = 'none'; // 兜底方案
                    }
					
					
                }
            },
        });
        //权限检查方法
        Vue.prototype.$_hashide = function (value) {
			
            let isExist = false;
			// var perms = localStorage.getItem("perms");
			// if(perms.indexOf(value)>-1){
			// 	isExist = true;
			// }
            // return isExist;
            
            const permsStr = localStorage.getItem("perms");
            // 若未存储权限，直接返回 false
            if (!permsStr) return false;
            // 增加 JSON 解析容错（建议保留，避免格式错误导致报错）
            let perms = [];
            try {
                perms = JSON.parse(permsStr);
            } catch (e) {
                console.error('权限数据解析失败：', e);
                return false;
            }

            // 将字符串解析为数组（注意：存储时需确保是 JSON 格式，避免解析错误）
            //const perms = JSON.parse(permsStr);
            // 用 includes 精确匹配数组中是否存在目标值
            return perms.includes(value);

        };
    }
};
export default hashidePermission;